import formatNumber from './formatNumber';
import { formatCurrency } from './formatters';

const formatAmount = (value, currency = '') =>
  `${formatNumber(parseFloat(value ?? 0), 2, 2)} ${formatCurrency(currency)}`;

export default formatAmount;
